/**
 * @generated SignedSource<<0c37ab55ff788d3a5cc8c19adf9a52bb>>
 * @relayHash 682006a4717140cff09b61df1192c4ea
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 83c9bb559f2ee12740a46e0dc8d69d0dc2ebd36452507787134a290ae0257b2a

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluencePrincipalType = "GROUP" | "USER" | "%future added value";
export type ContentRole = "DEFAULT" | "EDITOR" | "VIEWER" | "%future added value";
export type UpdateContentPermissionsInput = {
  confluencePrincipalType?: ConfluencePrincipalType | null;
  contentRole: ContentRole;
  principalId: string;
};
export type useUsersContentPermissionsUpdateContentPermissionsMutation$variables = {
  contentId: string;
  input: ReadonlyArray<UpdateContentPermissionsInput | null>;
};
export type useUsersContentPermissionsUpdateContentPermissionsMutation$data = {
  readonly updateContentPermissions: {
    readonly status: boolean;
  } | null;
};
export type useUsersContentPermissionsUpdateContentPermissionsMutation = {
  response: useUsersContentPermissionsUpdateContentPermissionsMutation$data;
  variables: useUsersContentPermissionsUpdateContentPermissionsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ContentPermissionsPayload",
    "kind": "LinkedField",
    "name": "updateContentPermissions",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "status"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useUsersContentPermissionsUpdateContentPermissionsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useUsersContentPermissionsUpdateContentPermissionsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "682006a4717140cff09b61df1192c4ea",
    "id": "83c9bb559f2ee12740a46e0dc8d69d0dc2ebd36452507787134a290ae0257b2a",
    "metadata": {},
    "name": "useUsersContentPermissionsUpdateContentPermissionsMutation",
    "operationKind": "mutation",
    "text": "mutation useUsersContentPermissionsUpdateContentPermissionsMutation($contentId:ID!,$input:[UpdateContentPermissionsInput]!){updateContentPermissions(contentId:$contentId,input:$input){status}}"
  }
};
})();

(node as any).hash = "69f9fc40c10deb46af31d8102cad6d9e";

export default node;
